import React, { useEffect, useState, useContext } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import NumericEntry_input_EmptyUse from '../../../../atoms/Input/NumericEntry_input_EmptyUse';
import { AppContext } from '../../../../../App';
import { FFT_MAX_VALUE_CLUDO, FFT_MAX_VALUE_ONPRE } from '../../../../../Constant';

import { NAME_DEV_SET } from '../../../../../function/NameDevSetModel';
import { DeviceRegistPageStyle, TableBaseStyle } from './../DeviceRegistStyle';
import VibrationSettingHeader from './VibrationSettingHeader';

export type VibrationSettingDialogBodyProps = {
  nameDevSetRow: NAME_DEV_SET;
  updateItem: (item: NAME_DEV_SET) => void;
};

const VibrationSettingDialogBody: React.FC<VibrationSettingDialogBodyProps> = (props: VibrationSettingDialogBodyProps) => {
  const { t } = useTranslation();
  const pageStyle = DeviceRegistPageStyle();
  const tableBaseStyle = TableBaseStyle();
  const { login } = useContext(AppContext);

  const [spdUpFreq, setSpdUpFreq] = useState<string>(props.nameDevSetRow.SPD_UP_FREQ !== null ? String(props.nameDevSetRow.SPD_UP_FREQ) : ''); //速度上限
  const [spdLoFreq, setSpdLoFreq] = useState<string>(props.nameDevSetRow.SPD_LO_FREQ !== null ? String(props.nameDevSetRow.SPD_LO_FREQ) : ''); //速度下限
  const [dspUpFreq, setDspUpFreq] = useState<string>(props.nameDevSetRow.DSP_UP_FREQ !== null ? String(props.nameDevSetRow.DSP_UP_FREQ) : ''); //変位上限
  const [dspLoFreq, setDspLoFreq] = useState<string>(props.nameDevSetRow.DSP_LO_FREQ !== null ? String(props.nameDevSetRow.DSP_LO_FREQ) : ''); //変位下限下

  useEffect(() => {
    console.debug("VibrationSettingDialogBody useEffect body", props.nameDevSetRow.SMOOTH_W0);
    setSpdUpFreq(props.nameDevSetRow.SPD_UP_FREQ !== null ? String(props.nameDevSetRow.SPD_UP_FREQ) : '');
    setSpdLoFreq(props.nameDevSetRow.SPD_LO_FREQ !== null ? String(props.nameDevSetRow.SPD_LO_FREQ) : '');
    setDspUpFreq(props.nameDevSetRow.DSP_UP_FREQ !== null ? String(props.nameDevSetRow.DSP_UP_FREQ) : '');
    setDspLoFreq(props.nameDevSetRow.DSP_LO_FREQ !== null ? String(props.nameDevSetRow.DSP_LO_FREQ) : '');
  }, [])

  return (
    <>
      <TableContainer className={pageStyle.tableDialgContainer}>
        <Table aria-label="judgeSetting">
          <TableHead>
            <VibrationSettingHeader />
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className={tableBaseStyle.dialogBodyCell} width={120}>
                {t('VibrationSettingDialogBody.振動速度', '振動(速度)')}
              </TableCell>
              {/** 振動(速度) 上限周波数 */}
              <TableCell className={tableBaseStyle.dialogBodyCell} width={250}>
                <NumericEntry_input_EmptyUse
                  className={tableBaseStyle.textFieldDialog}
                  value={spdUpFreq === '' ? null : Number(spdUpFreq)}
                  minValueLimit={1}
                  maxValueLimit={login.IsIoT ? FFT_MAX_VALUE_CLUDO : FFT_MAX_VALUE_ONPRE}
                  fixed={0}
                  onChange={(val) => {
                    setSpdUpFreq(String(val === null ? '' : val));
                    props.nameDevSetRow.SPD_UP_FREQ = val;
                    props.updateItem(props.nameDevSetRow);
                  }}
                />
              </TableCell>
              {/** 振動(速度) 下限周波数 */}
              <TableCell className={tableBaseStyle.dialogBodyCell} width={250}>
                <NumericEntry_input_EmptyUse
                  className={tableBaseStyle.textFieldDialog}
                  value={spdLoFreq === '' ? null : Number(spdLoFreq)}
                  minValueLimit={1}
                  maxValueLimit={login.IsIoT ? FFT_MAX_VALUE_CLUDO : FFT_MAX_VALUE_ONPRE}
                  fixed={0}
                  onChange={(val) => {
                    setSpdLoFreq(String(val === null ? '' : val));
                    props.nameDevSetRow.SPD_LO_FREQ = val;
                    props.updateItem(props.nameDevSetRow);
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={tableBaseStyle.dialogBodyCell} width={120}>
                {t('VibrationSettingDialogBody.振動変位', '振動(変位)')}
              </TableCell>
              {/** 振動(変位) 上限周波数 */}
              <TableCell className={tableBaseStyle.dialogBodyCell} width={250}>
                <NumericEntry_input_EmptyUse
                  className={tableBaseStyle.textFieldDialog}
                  value={dspUpFreq === '' ? null : Number(dspUpFreq)}
                  minValueLimit={1}
                  maxValueLimit={login.IsIoT ? FFT_MAX_VALUE_CLUDO : FFT_MAX_VALUE_ONPRE}
                  fixed={0}
                  onChange={(val) => {
                    setDspUpFreq(String(val === null ? '' : val));
                    props.nameDevSetRow.DSP_UP_FREQ = val;
                    props.updateItem(props.nameDevSetRow);
                  }}
                />
              </TableCell>
              {/** 振動(変位) 下限周波数 */}
              <TableCell className={tableBaseStyle.dialogBodyCell} width={250}>
                <NumericEntry_input_EmptyUse
                  className={tableBaseStyle.textFieldDialog}
                  value={dspLoFreq === '' ? null : Number(dspLoFreq)}
                  minValueLimit={1}
                  maxValueLimit={login.IsIoT ? FFT_MAX_VALUE_CLUDO : FFT_MAX_VALUE_ONPRE}
                  fixed={0}
                  onChange={(val) => {
                    setDspLoFreq(String(val === null ? '' : val));
                    props.nameDevSetRow.DSP_LO_FREQ = val;
                    props.updateItem(props.nameDevSetRow);
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
export default VibrationSettingDialogBody;